interface Experience {
  id: string;
  company_name: string;
  position: string;
  start_date: string;
  end_date?: string;
  description?: string;
  achievements?: string[];
}

interface ExperienceSectionProps {
  experiences: Experience[];
}

export const ExperienceSection = ({ experiences }: ExperienceSectionProps) => {
  if (experiences.length === 0) return null;

  return (
    <section id="experience" className="section-padding">
      <div className="max-w-6xl mx-auto container-padding">
        <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-3 animate-fade-in">
          Experience
        </h2>
        <p className="text-muted-foreground mb-10 animate-fade-in animation-delay-100">
          Roles where I've led, shipped, and collaborated.
        </p>

        <div className="space-y-8">
          {experiences.map((exp, index) => (
            <div
              key={exp.id}
              className="pl-5 border-l-2 border-border hover:border-primary/60 transition-colors duration-200 animate-fade-in"
              style={{ animationDelay: `${(index + 1) * 100}ms` }}
            >
              <p className="text-xs uppercase tracking-wider text-muted-foreground mb-1.5 font-medium">
                {exp.start_date} – {exp.end_date || "Present"}
              </p>
              
              <h3 className="text-lg font-semibold text-foreground mb-1.5">
                {exp.position} <span className="text-muted-foreground font-normal">— {exp.company_name}</span>
              </h3>
              
              {exp.description && (
                <p className="text-muted-foreground mb-4 leading-relaxed">
                  {exp.description}
                </p>
              )}
              
              {exp.achievements && exp.achievements.length > 0 && (
                <ul className="space-y-2">
                  {exp.achievements.map((achievement, idx) => (
                    <li key={idx} className="flex gap-3 text-sm text-muted-foreground">
                      <span className="text-primary font-bold mt-0.5">•</span>
                      <span className="leading-relaxed">{achievement}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
